import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormBySchema, FormFieldLayout, isTmpId, useAPIWrapper } from 'drf-react-by-schema';

import { useAppSelector } from 'src/app/hooks';
import { appDispatch } from 'src/utils/utils';
import { setPage } from 'src/features/pageSlice';
import { PageType } from 'src/constants/PageType';
import { formLayout } from 'src/styles/layout';

const MODEL = 'entreposto';

const FIELDS_LAYOUT: FormFieldLayout[] = [
  {
    title: 'Identificação',
    rows: ['nome', 'municipio'],
  },
  {
    title: 'Grupos de origem dos flocos',
    rows: ['grupos_fornecedores'],
  },
  {
    title: 'Logomarca ou imagem',
    rows: ['logomarca'],
  },
];

export default function EntrepostoForm() {
  const { id, key, type, formValues } = useAppSelector((state) => state.page);
  const { pageForm, loadSinglePageData, onEditModel } = useAPIWrapper();
  const {
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { errors, isDirty },
    register,
  } = useForm({
    mode: 'onBlur',
    resolver: pageForm?.validationSchema ? yupResolver(pageForm.validationSchema) : undefined,
  });

  const hiddenFields = ['id'];

  useEffect(() => {
    if (!key) {
      return;
    }

    const loadAllDataAsync = async () => {
      const values = await loadSinglePageData({
        model: MODEL,
        objId: id,
        fieldsLayout: FIELDS_LAYOUT,
      });
      if (values) {
        reset(values);
        const submitSuccessTarget = `/${key}/view/${isTmpId(id) ? '{ID}' : id}/?type=${isTmpId(id) ? PageType.CREATE : PageType.EDIT}`;
        appDispatch(
          setPage({
            model: MODEL,
            // title: pageTitle,
            formValues: values,
            submitSuccessTarget,
          })
        );
      }
    };
    loadAllDataAsync();
  }, [id, key, type]);

  useEffect(() => {
    appDispatch(
      setPage({
        formDisabled: !isDirty,
      })
    );
  }, [isDirty]);

  useEffect(() => {
    appDispatch(
      setPage({
        handleSubmit,
      })
    );
  }, [handleSubmit]);

  if (!pageForm?.schema || !formValues || !key || !type) {
    return null;
  }

  return (
    <FormBySchema
      fieldsLayout={FIELDS_LAYOUT}
      hiddenFields={hiddenFields}
      control={control}
      register={register}
      errors={errors}
      schema={pageForm.schema}
      onEditModel={onEditModel}
      getValues={getValues}
      setValue={setValue}
      elevation={0}
      {...formLayout}
    />
  );
}
